import type { IconData } from '@stacksjs/iconify-core'

export const td1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"#002664\" d=\"M0 0h171.2v512H0z\"/><path fill=\"#c60c30\" d=\"M340.8 0H512v512H340.8z\"/><path fill=\"#fecb00\" d=\"M171.2 0h169.6v512H171.2z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default td1x1
